import ReactMarkdown from 'react-markdown'
import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
interface DescriptionProps {
  description: string
}

const Article = styled('article')({
  paddingTop: 0,
})

const Content = styled('section')({
  marginBottom: 0,
  '&.limit': {
    height: 200,
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
  },
})

const Toggle = styled('button')({
  display: 'block',
  background: 'transparent',
  cursor: 'pointer',
  textDecoration: 'underline',
  lineHeight: 1.5,
  fontSize: '1rem',
  fontWeight: 600,
  margin: '0 auto',
  border: 0,
  color: '#AF231C',
})

const Description: React.FC<DescriptionProps> = ({ description }): JSX.Element => {
  const isLongDescription = description?.length > 450
  const [isReadMore, setIsReadMore] = useState<boolean>(isLongDescription)
  const toggleReadMore = (): void => {
    setIsReadMore(!isReadMore)
  }

  return (
    <Article>
      <Content className={isReadMore ? 'limit' : ''}>
        <ReactMarkdown>{description}</ReactMarkdown>
      </Content>
      {isLongDescription && (
        <Toggle onClick={toggleReadMore}>
          {isReadMore ? (
            <>
              Read more <span aria-hidden='true'>+</span>
            </>
          ) : (
            <>
              Read less <span aria-hidden='true'>-</span>
            </>
          )}
        </Toggle>
      )}
    </Article>
  )
}

export default Description
